import script from "./serviceOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./serviceOrders.vue?vue&type=script&setup=true&lang=js"

import "./serviceOrders.vue?vue&type=style&index=0&id=779e2b77&lang=scss"

const __exports__ = script;

export default __exports__